<template>
    <div class="record">
        <div class="tips_text">
            <img class="tips_icon" referrerpolicy="no-referrer" src="../../assets/img/tips.png" alt="" />
            <span class="tips_span">&nbsp;&nbsp;顾客“{{customerName}}”暂未绑定至对应的微信客户，若已添加该客户微信，可在此页面手动绑定，若未添加该顾客信，可</span>
            <span class="tips_link" @click="toAddCustomer()">点击此处进行添加</span>
        </div>
        <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="请输入搜索关键词"
            left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
        </van-search>
        <div class="todoList-module">
            <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
                <div class="main-box">
                    <div class="list" v-if="customerList.length != 0">
                        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getCustomersList"
                            :offset="20" :immediate-check="false">
                            <div class="list-inner" v-for="item,index in customerList" :key="index">
                                <div class="list-card flex-row">
                                    <div class="image-inner flex-col">
                                        <img class="image" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                                    </div>
                                    <div class="text-inner  flex-row justify-between">
                                        <span class="list-name">{{item.username}}</span>
                                    </div>
                                    <!-- 已绑定可以解除绑定 -->
                                    <div v-if="item.connectionType==2" class="binding  flex-col justify-between"
                                        @click="toBinding(item)">
                                        <span class="binding_text">绑定</span>
                                    </div>
                                    <!--  已解除绑定可以绑定 -->
                                    <div v-else class="unBinding  flex-col justify-between" @click="toBinding(item)">
                                        <span class="unbinding_text">解除绑定</span>
                                    </div>
                                </div>
                                <div class="section_6 flex-col"></div>
                            </div>
                        </van-list>
                    </div>
                    <div v-else class="flex flex-col flex-y-center">
                        <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png"
                            alt="" class="empty-icon" />
                        <div class="empty-txt">暂无数据～</div>
                    </div>
                </div>
            </van-pull-refresh>

        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Dialog, Toast } from "vant";
import { navigateToAddCustomer } from '@/utils/wxCodeAuth'

export default {
    name: 'toBindingCustomer',
    components: {
    },
    data() {
        return {
            searchStr: "",
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            total: 0,
            customerList: [],
            customerName: "",
            customerMobile: "",
            accountNo: "",
            pageName: "",
            customerListPage: 1,
            customerListSearchStr: "",
            customerListQueryType: "",

        }
    },
    mounted() {
        this.customerListPage = this.$route.query.customerListPage
        this.customerListSearchStr = this.$route.query.customerListSearchStr
        this.customerListQueryType = this.$route.query.customerListQueryType
        this.pageName = this.$route.query.pageName
        this.customerName = this.$route.query.custName
        this.customerMobile = this.$route.query.mobile
        this.accountNo = this.$route.query.accountNo
        this.getCustomersList()
    },
    methods: {
        // 获取顾客列表
        getCustomersList() {
            const limit = 10
            this.loading = true
            request({
                url: `/contact/wxContactPage`,
                method: "get",
                params: { limit, page: this.page, searchStr: this.searchStr }
            })
                .then((res) => {
                    this.customerList = this.page == 1 ? res.data.list : this.customerList.concat(res.data.list);
                    this.page += 1;
                    this.total = res.data.total;
                    // 数据全部加载完成
                    if (this.customerList.length >= this.total) {
                        this.finished = true;
                    }
                })
                .catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false
                    this.refreshing = false
                })
        },

        onRefresh() {
            this.page = 1
            this.finished = false;
            this.customerList = []
            this.getCustomersList()
        },

        selClear() {
            this.searchStr = "";
        },
        //搜索
        onSearch() {
            this.page = 1;
            this.customerList = [];
            this.getCustomersList();
        },
        //添加客户
        toAddCustomer() {
            navigateToAddCustomer('')
        },

        //解绑或绑定
        toBinding(item) {
            var message = "";
            var param = {};
            if (item.connectionType == 1)   //解除绑定
            {
                param = {
                    contactId: item.id,     //企业微信顾客ID
                    contactName: item.username,    //企业微信顾客名称
                    type: 2
                };
                message = `是否确认将微信客户“${item.username}”与顾客“${item.nickname}”解除绑定？`;
            }
            else   //绑定
            {
                message = `是否确认将微信客户“${item.username}”绑定至顾客“${this.customerName}”？`;
                param = {
                    accountNo: this.accountNo,    //POS顾客账户号
                    customerMobile: this.customerMobile,      //POS顾客手机号
                    customerName: this.customerName,     //POS顾客名称
                    contactId: item.id,     //企业微信顾客ID
                    contactName: item.username,    //企业微信顾客名称
                    type: 1
                };

            }
            Dialog.confirm({
                title: '客户绑定',
                message: message,
            })
                .then(() => {
                    request({
                        url: `/contact/bindCustomerConnection`,
                        method: "post",
                        data: param,
                    })
                        .then((res) => {
                            //解除绑定停留在当前页，绑定完成则返回到前一页的内容
                            if (item.connectionType == 1)   //解除绑定
                            {
                                //留在当前页
                                this.page = 1;
                                this.customerList = [];
                                this.getCustomersList();
                            }
                            else {
                                if (this.pageName == "toDoDetail" || this.pageName == "customerChurnDetail" || this.pageName == "commonPool") {
                                    this.$router.go(-1)
                                }
                                else {
                                    this.$router.push({ name: "customerList", query: { customerListPage: this.customerListPage, customerListSearchStr: this.customerListSearchStr, customerListQueryType: this.customerListQueryType } });
                                    // window.history.go(-1);
                                }
                            }
                        }).catch((error) => {
                            Toast({ position: 'top', message: error ?? '' })
                        });
                })
                .catch(() => {
                    // on cancel
                });
        }

    },
}
</script>

<style scoped lang="less">
.tips_icon {
    width: 24px;
    height: 24px;
    background-size: 100% 100%;
}

.tips_text {
    width: 700px;
    overflow-wrap: break-word;
    font-size: 0;
    text-align: left;
    line-height: 40px;
    margin-top: 40px;
    margin-left: 30px;
}

.tips_span {
    width: 690px;
    height: 120px;
    overflow-wrap: break-word;
    color: rgba(162, 171, 181, 1);
    font-size: 28px;
    text-align: left;
    line-height: 40px;
}

.tips_link {
    width: 690px;
    height: 120px;
    overflow-wrap: break-word;
    color: rgba(87, 111, 201, 1);
    font-size: 28px;
    text-decoration: underline;
    text-align: left;
    line-height: 40px;
}

.record {
    height: 100vh;
}
.todoList-module {
    height: 100%;
    box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02) inset;
    background-color: #f9fafc;
    overflow-y: auto;
}
.main-box {
    min-height: calc(100vh - 200px);
    padding-bottom: 130px;
}
.list {
    background-color: #fff;
    min-height: calc(100vh - 200px);
}

.list-inner {
    background: #ffffff;
    border-radius: 20px;
}
.list-card {
    height: 130px;
    background-color: rgb(255 255 255);
}

.image {
    z-index: 38;
    position: absolute;
    left: 0;
    top: 0;
    width: 70px;
    height: 70px;
}
.image-inner {
    z-index: 37;
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    overflow: hidden;
    margin-left: 30px;
    margin-top: 30px;
}

.text-inner {
    width: 90px;
    height: 92px;
    margin-left: 30px;
    margin-top: 50px;
}
.list-name {
    width: 90px;
    height: 42px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 30px;
    white-space: nowrap;
    line-height: 42px;
    text-align: left;
}
.section_6 {
    width: 600px;
    height: 1px;
    background-color: rgba(215, 215, 215, 1);
    margin: 2px 0 0 130px;
}
.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}
.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}
.binding {
    min-width: 120px;
    height: 60px;
    background: #3fb8e2;
    border-radius: 4px;
    margin: 44px 0 0 380px;
}
.binding_text {
    // width: 52px;
    height: 37px;
    font-size: 26px;
    color: #ffffff;
    line-height: 37px;
    margin: 13px 0 0 35px;
}
.unBinding {
    min-width: 120px;
    height: 60px;
    border-radius: 4px;
    border: 2px solid #3fb8e2;
    margin: 44px 0 0 378px;
}
.unbinding_text {
    // width: 104px;
    height: 37px;
    font-size: 26px;
    color: #3fb8e2;
    line-height: 37px;
    margin: 13px 0 0 5px;
}

:deep(.van-list__finished-text) {
    height: 300px !important;
}

:deep(.search-button.van-search) {
    padding: 30px 30px 30px 30px;
}
:deep(.search-button .van-icon) {
    font-size: 28px;
}
:deep(.search-button .van-search__content) {
    padding-left: 20px !important;
}
:deep(.search-button .van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 0 !important;
    margin-right: 0 !important;
}
:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
</style>
